import { useEffect, useRef, useState } from "react";
import { Row, Col, Form, Select, DatePicker, Input, Tabs, Button } from "antd";
import { Down } from "@icon-park/react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import dayjs from "dayjs";
import PasswordChange from "./PasswordChange";
import { useDispatch } from "react-redux";
import { userInfoAction } from "../../Redux/actions/userInfoAction";
import moment from "moment";
import Header from "../../components/Includes/Header";
import { useFetch } from "../../Services/useFetch";
import { DocImgBaseUrl } from "../../utils/configurable";
import { fetchAuthMode, ssoChangePasswordUrl } from "../../utils/docGridSso";

const { TextArea } = Input;

const intialState = {
  country_id: null,
  state_id: null,
  city_id: null,
  date_of_birth: null,
  full_address_1: "",
  zip_code: "",
  password: "",
  confirmPassword: "",
  old_password: "",
};

const Profile = () => {
  const [form] = Form.useForm();
  const [formdata] = Form.useForm();
  // idp mode: passwords live only in the company login.
  const [isIdpMode, setIsIdpMode] = useState(false);

  useEffect(() => {
    fetchAuthMode().then((mode) => setIsIdpMode(mode === "idp"));
  }, []);
  const [userName, setUserName] = useState([]);
  const [skeleton, setSkeleton] = useState(true);
  const { userData } = useSelector((state) => state.loginData);
  const { userInfo } = useSelector((state) => state.userDetails);
  const dispatch = useDispatch();
  const [personalInputData, setPersonalInputData] = useState(intialState);
  const [profileCountry, setProfileCountry] = useState([]);
  const [profileState, setProfileState] = useState([]);
  const [profileCity, setProfileCity] = useState([]);
  const notify = (error) => toast.error(error);
  const notifySuccess = (msg) => toast.success(msg);
  const { request } = useFetch();

  const profileInputRef = useRef(null);

  const handleDivClick = () => {
    profileInputRef.current.click();
  };

  const disableFutureDates = (current) => {
    // Disable all dates after today
    return current && current > moment().endOf("day");
  };
  const BdUserdetails = async () => {
    const formData = new URLSearchParams();
    formData.append("user_id", Number(userData?.data?.id));
    try {
      // const response = await ProfileDetails.getuserdetails(formData);
      const response = await request("/user-details-edit", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status == 1) {
        setUserName(response.data.data);
        dispatch(
          userInfoAction({
            ...userInfo,
            profileimg: response.data.data?.profileimg,
            profileimg_path: response.data.data?.profileimg_path,
          })
        );
      } else {
        setUserName([]);
        notify(response?.response?.data?.message);
      }
    } catch (error) {
      console.log(error, "api error");
    }
  };

  const fetchUserUpdateDetails = async (value) => {
    try {
      const formdata = new URLSearchParams();
      formdata.append("update_user_id", Number(userName?.id));
      formdata.append("firstname", userName?.firstname);
      formdata.append("lastname", userName?.lastname);
      formdata.append("contactnumber", userName?.contactnumber);
      formdata.append("email", userName?.email);
      formdata.append("country_id", value?.country_id);
      formdata.append("state_id", value?.state_id);
      formdata.append("city_id", value?.city_id);
      formdata.append("full_address_1", value?.full_address_1);
      formdata.append("zip_code", value?.zip_code);
      formdata.append(
        "date_of_birth",
        value?.date_of_birth !== null ? dayjs(value?.date_of_birth)?.format("YYYY-MM-DD") : ""
      );
      // const response = await userDetailsApi.updateUserDetail(formdata);
      const response = await request("/user-details-update", "put", formdata, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status == 1) {
        // setPersonalInputData(intialState)
        BdUserdetails();
        handleReset();
        notifySuccess(response?.data?.message);
      } else {
        // notify(response?.response?.data?.message);
        // handleReset()
      }
    } catch (error) {
      console.log(error, "Api Error");
    }
  };

  const getAddTenderCountry = async () => {
    try {
      const response = await request("/country-list", "get");

      if (response?.data?.status === "1") {
        setProfileCountry(response?.data?.data);
      }
    } catch (error) {
      console.log(error, "api erorr");
    }
  };

  const getAddTenderState = async () => {
    const formData = new URLSearchParams();
    formData.append("country_id", personalInputData?.country_id);
    try {
      // const response = await AddTenderList.getTenderStateList(formData)
      const response = await request("/state-list", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status === "1") {
        setProfileState(response?.data?.data);
      }
    } catch (error) {
      console.log(error, "api erorr");
    }
  };

  const getAddTenderCity = async () => {
    const formData = new URLSearchParams();
    formData.append("state_id", personalInputData?.state_id);
    try {
      // const response = await AddTenderList.getTenderCityList(formData)
      const response = await request("/city-list", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status === "1") {
        setProfileCity(response?.data?.data);
      }
    } catch (error) {
      console.log(error, "api erorr");
    }
  };

  useEffect(() => {
    getAddTenderCountry();
  }, []);

  useEffect(() => {
    getAddTenderState();
  }, [personalInputData?.country_id]);

  useEffect(() => {
    getAddTenderCity();
  }, [personalInputData?.state_id]);

  const handleReset = () => {
    setPersonalInputData("");
    formdata?.resetFields();
  };

  const handleInputChange = (name, value, date) => {
    if (name === "country_id") {
      formdata?.setFieldsValue({
        state_id: "",
        city_id: "",
      });
    }
    if (name === "state_id") {
      formdata?.setFieldsValue({
        city_id: "",
      });
    }
    setPersonalInputData({
      ...personalInputData,
      [name]: value,
    });
  };

  const location = useLocation();
  const val = location?.pathname;
  const str = val.replace("/", "");

  useEffect(() => {
    if (userInfo?.id) {
      BdUserdetails();
    }
  }, [userInfo?.id]);

  useEffect(() => {
    setSkeleton(true);
    const timer = setTimeout(() => setSkeleton(false), 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [form?.length]);

  // passord api --- khushbu
  const postPasswordChange = async (handleResetChangePassword) => {
    const { password, confirmPassword, old_password } = personalInputData;
    try {
      const formData = new URLSearchParams();
      formData.append("user_id", userInfo?.id);
      formData.append("old_password", old_password);
      await form.validateFields();
      // const response = await userDetailsApi?.oldPassword(formData);
      const response = await request("/check-user-old-password", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response.data.status !== "1") {
        notify("Old Password is incorrect!!");
      }

      if (password === confirmPassword) {
        const formData = new URLSearchParams();
        formData.append("user_id", userInfo?.id);
        formData.append("password", password);
        await form.validateFields();
        // const response = await userDetailsApi?.changePassword(formData);
        const response = await request("/user-change-password", "post", formData, {
          "Content-Type": "application/x-www-form-urlencoded",
        });

        if (response.data.status === "1") {
          setPersonalInputData(response?.data?.message);
          notifySuccess(response?.data?.message);
          handleReset();
          handleResetChangePassword();
        } else {
          notify(response?.response?.data?.message);
        }
      } else {
        notify("Passwords do not match or do not meet criteria");
      }
    } catch (error) {
      notify("Old Password is incorrect!");
      console.log("Server error");
    }
  };
  const getEditDetails = () => {
    const newObj = {
      // profileImg: userName?.profileimg || '',
      country_id: userName?.country_id || "",
      state_id: userName?.state_id || "",
      city_id: userName?.city_id || "",
      date_of_birth: userName?.date_of_birth !== null ? dayjs(userName?.date_of_birth) : null,
      full_address_1: userName?.full_address_1 || "",
      zip_code: userName?.zip_code,
    };
    setPersonalInputData((prevState) => {
      return {
        ...prevState,
        ...newObj,
      };
    });
    form.setFieldsValue(newObj);
    formdata.setFieldsValue(newObj);
  };

  useEffect(() => {
    if (userName?.country_id) {
      getEditDetails();
    }
  }, [userName]);

  function handleImageChange(event) {
    const file = event.target.files[0];
    updateProfilePicture(file);
  }

  const updateProfilePicture = async (file) => {
    const formData = new FormData();
    formData.append("user_id", Number(userData?.data?.id));
    formData.append("files", file);
    try {
      // const response = await userDetailsApi.updateUserProfilePic(formData);
      const response = await request("/user-profile-pic-update", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status === "1") {
        BdUserdetails();
        notifySuccess("Logo updated successfully");
      } else {
        notify(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("API Error:", error);
      notify("Error updating logo");
    }
  };

  const validateZipCode = (_, value) => {
    if (value && value.length > 6) {
      return Promise.reject("Zip code must not exceed 6 characters");
    }
    return Promise.resolve();
  };

  return (
    <>
      <>
        {/* <Breadcrumb data={str} /> */}
        <Header />
        <div className="bd_profile_main">
          <div className="bd_main_profile_headings">
            {" "}
            <h2 style={{ margin: "20px" }}>My Profile</h2>
            <div className="bd_main_add">
              <div className="bd_main_sub_add_profile">
                <div className="bd_main_sub_image">
                  {userInfo.profileimg !== null ? (
                    <img
                      alt=""
                      className="img-thumbnail rounded-circle"
                      src={`${DocImgBaseUrl}${userInfo.profileimg_path}/${userInfo.profileimg}`}
                    />
                  ) : (
                    <div
                      style={{
                        background: "#000",
                        color: "white",
                        borderRadius: "50%",
                        aspectRatio: "1/1",
                        overflow: "hidden",
                        padding: "1rem",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="150px"
                        height="150px"
                        fill="currentColor"
                        className="bi bi-person"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                      </svg>
                    </div>
                  )}

                  <div className="bd_main_update_profile_btn" onClick={handleDivClick}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-pencil-square"
                      viewBox="0 0 16 16"
                    >
                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                      <path
                        fillRule="evenodd"
                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                      />
                    </svg>
                    <input
                      ref={profileInputRef}
                      className="input_update_file"
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                    />
                  </div>
                </div>
                {/* <div className="line_through"></div> */}
                <div className="bd_main_sub_info">
                  {skeleton ? (
                    <>
                      <div className="main_details">
                        <div className="sub_emp_id">
                          <Skeleton variant="rectangular" width={120} height={25} />
                        </div>
                        <div className="sub_emp_id">
                          {/* <Skeleton variant="rectangular" width={100} height={25} /> */}
                          <Skeleton variant="rectangular" width={100} height={25} />
                        </div>
                      </div>
                      <div className="main_details">
                        <div className="sub_contact">
                          <p className="sub_pera">
                            {" "}
                            <span className="sub_span">Email:</span>
                            <Skeleton variant="rectangular" width={120} height={22} />
                          </p>
                          <p className="sub_pera">
                            {" "}
                            <span className="sub_span">Contact:</span>
                            <Skeleton variant="rectangular" width={120} height={22} />
                          </p>
                        </div>
                        {userData?.data?.permanent_sys_adm === "1" && (
                          <div className="sub_contact">
                            <p className="sub_pera">
                              {" "}
                              <span className="sub_span">Remaining User Limit:</span>
                              <Skeleton variant="rectangular" width={150} height={23} />
                            </p>
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="sub_emp_id">
                        <span className="sub_emp_head">{userName.userfullname}</span>
                        <span className="sub_id">{personalInputData?.role?.map((item) => item?.role_name)}</span>
                      </div>
                      <div className="main_details">
                        <div className="sub_contact">
                          <p className="sub_pera">
                            {" "}
                            <span className="sub_span">Email:</span> {userName?.email}
                          </p>
                          <p className="sub_pera">
                            {" "}
                            <span className="sub_span">Contact:</span>
                            {userName?.contactnumber}{" "}
                          </p>
                        </div>

                        {userData?.data?.permanent_sys_adm === "1" && (
                          <div className="sub_contact">
                            <p className="sub_pera">
                              {" "}
                              <span className="sub_span">Remaining User Limit:</span>
                              {userName?.user_limit}{" "}
                            </p>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* <--------- tabs -------> */}
          <div className="bd_main_profile_tabs">
            <div className="profile_tabs_heading">
              <Tabs
                defaultActiveKey="1"
                items={[
                  {
                    label: "Official",
                    key: "1",
                    children: (
                      <div className="profile_detail_info_box">
                        <Form
                          // form={form}
                          layout="vertical"
                        >
                          <Row gutter={20}>
                            <Col sm={12} md={6} xs={24}>
                              <Form.Item label="First Name">
                                <Input placeholder="Enter Here" disabled={true} value={userName?.firstname} />
                              </Form.Item>
                            </Col>
                            <Col sm={12} md={6} xs={24}>
                              <Form.Item label="Last Name">
                                <Input placeholder="Enter Here" disabled={true} value={userName?.lastname} />
                              </Form.Item>
                            </Col>
                            <Col sm={12} md={6} xs={24}>
                              <Form.Item label="Offical Email ">
                                <Input placeholder="Enter Here" value={userName?.email} disabled={true} />
                              </Form.Item>
                            </Col>
                            <Col sm={12} md={6} xs={24}>
                              <Form.Item label="Mobile Number">
                                <Input placeholder="Enter Here" value={userName?.contactnumber} disabled={true} />
                              </Form.Item>
                            </Col>
                            <Col sm={12} md={6} xs={24}>
                              <Form.Item label="System Admin">
                                <Input
                                  placeholder="Enter Here"
                                  value={userName?.permanent_sys_adm === "1" ? "Yes" : "No"}
                                  disabled={true}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                    ),
                  },
                  {
                    label: "Personal",
                    key: "2",
                    children: (
                      <div className="profile_detail_info_box">
                        <div className="profile_sub_info">
                          <Form
                            form={formdata}
                            layout="vertical"
                            // name="control-hooks"
                            autoComplete="off"
                            onFinish={fetchUserUpdateDetails}
                          >
                            <Row gutter={20}>
                              <Col sm={12} md={6} xs={24}>
                                <Form.Item
                                  label="DOB"
                                  name="date_of_birth"
                                  rules={[
                                    {
                                      required: true,
                                      message: "DOB is required",
                                    },
                                  ]}
                                >
                                  <DatePicker
                                    name="date_of_birth"
                                    placeholder="Select Date"
                                    value={
                                      personalInputData?.date_of_birth ? moment(personalInputData.date_of_birth) : null
                                    }
                                    onChange={(value) => handleInputChange("date_of_birth", value)}
                                    disabledDate={disableFutureDates}
                                  />
                                </Form.Item>
                              </Col>

                              <Col sm={12} md={6} xs={24}>
                                <Form.Item
                                  label="Country Id"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Country is required",
                                    },
                                  ]}
                                  name="country_id"
                                >
                                  <Select
                                    showSearch
                                    value={personalInputData?.country_id}
                                    onChange={(value) => handleInputChange("country_id", value)}
                                    placeholder="Select Country"
                                    options={profileCountry?.map((item, index) => {
                                      return {
                                        value: item?.id,
                                        label: item?.country_name,
                                      };
                                    })}
                                    suffixIcon={<Down theme="outline" size="18" fill="#747474" />}
                                    filterOption={(input, option) =>
                                      option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col sm={12} md={6} xs={24}>
                                <Form.Item
                                  label="State Id "
                                  rules={[
                                    {
                                      required: true,
                                      message: "State is required",
                                    },
                                  ]}
                                  name="state_id"
                                >
                                  <Select
                                    showSearch
                                    value={personalInputData.state_id}
                                    onChange={(value) => handleInputChange("state_id", value)}
                                    options={profileState?.map((item, index) => {
                                      return {
                                        value: item?.id,
                                        label: item?.state_name,
                                      };
                                    })}
                                    placeholder="Select State"
                                    // name='state_id'
                                    suffixIcon={<Down theme="outline" size="18" fill="#747474" />}
                                    filterOption={(input, option) =>
                                      option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                  ></Select>
                                </Form.Item>
                              </Col>
                              <Col sm={12} md={6} xs={24}>
                                <Form.Item
                                  label="City Id"
                                  rules={[
                                    {
                                      required: true,
                                      message: "City is required",
                                    },
                                  ]}
                                  name="city_id"
                                >
                                  <Select
                                    showSearch
                                    value={personalInputData.city_id}
                                    onChange={(value) => handleInputChange("city_id", value)}
                                    options={profileCity?.map((item, index) => {
                                      return {
                                        value: item?.id,
                                        label: item?.city_name,
                                      };
                                    })}
                                    // name='city_id'
                                    placeholder="Select City"
                                    suffixIcon={<Down theme="outline" size="18" fill="#747474" />}
                                    filterOption={(input, option) =>
                                      option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col sm={12} md={6} xs={24}>
                                <Form.Item
                                  label="Zip Code"
                                  name="zip_code"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Zip Code is required",
                                    },
                                    { validator: validateZipCode },
                                  ]}
                                >
                                  <Input
                                    // name='zip_code'
                                    placeholder="Zip Code"
                                    value={personalInputData?.zip_code}
                                    onChange={(e) => handleInputChange("zip_code", e.target.value)}
                                  />
                                </Form.Item>
                              </Col>

                              <Col sm={12} md={6} xs={24}>
                                <Form.Item
                                  label="Full Address"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Address is required",
                                    },
                                  ]}
                                  name="full_address_1"
                                >
                                  <TextArea
                                    // name='full_address_1'
                                    placeholder="Full address"
                                    value={personalInputData?.full_address_1}
                                    onChange={(e) => handleInputChange("full_address_1", e.target.value)}
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                            <div className="profile_button_sec">
                              <Button className="BG_ghostButton" onClick={handleReset}>
                                Reset
                              </Button>
                              <Button className="BG_mainButton" htmlType="submit">
                                Save & Change
                              </Button>
                            </div>
                          </Form>
                        </div>
                      </div>
                    ),
                  },
                  {
                    label: "Change Password",
                    key: "3",
                    // idp mode: the password lives in the company login (Auth),
                    // whose page brings the user back to DocGrid afterwards.
                    children: isIdpMode ? (
                      <div style={{ padding: "16px 0" }}>
                        <p>Your password is managed in the company login.</p>
                        <div className="profile_button_sec">
                          <Button
                            className="BG_mainButton"
                            onClick={() => window.location.assign(ssoChangePasswordUrl)}
                          >
                            Change password
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <PasswordChange
                        // form={form}
                        personalInputData={personalInputData}
                        handleInputChange={handleInputChange}
                        handleReset={handleReset}
                        postPasswordChange={postPasswordChange}
                        setPersonalInputData={setPersonalInputData}
                        isAdmin={false}
                      />
                    ),
                  },
                ].filter(Boolean)}
              />
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default Profile;
